import { render, staticRenderFns } from "./Stampa.vue?vue&type=template&id=766ea154&"
import script from "./Stampa.vue?vue&type=script&lang=js&"
export * from "./Stampa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports